"use client"
import SafeProvider from "@safe-global/safe-apps-react-sdk"

export const Provider = SafeProvider
